export default __webpack_public_path__ + "static/media/title_zh_tw_pc@2x.6d1e8d82.png";